import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(() => ({
  text: {
    display: 'inline-block'
  }
}));
